import { Outlet } from "react-router-dom";
import Navigation from "@/components/grant/Navigation";
import Footer from "@/components/grant/Footer";
import GradientTransition from "@/components/grant/GradientTransition";
import TrialBanner from "./TrialBanner";
import OnboardingBanner from "@/components/onboarding/OnboardingBanner";

const MainLayout = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <GradientTransition position="top" />
      <TrialBanner />
      <OnboardingBanner />
      <Outlet />
      <GradientTransition position="bottom" />
      <Footer />
    </div>
  );
};

export default MainLayout;
